import type {
  WireAddOnContract,
  WireContract,
  WireMasterContract,
  WireOfferQuote,
  WireOfferQuoteChild,
  WireOfferQuoteMaster,
  WireSpaceRentalContract,
} from "../types";

const findMasterContract = (
  contracts: WireContract[],
): WireMasterContract | undefined =>
  contracts.find((contract) => contract.type === "MASTER") as
    | WireMasterContract
    | undefined;

const findSpaceRentalContract = (
  contracts: WireContract[],
): WireSpaceRentalContract | undefined =>
  contracts.find((contract) => contract.type === "SPACE_RENTAL") as
    | WireSpaceRentalContract
    | undefined;

const findAddOnsContracts = (
  contracts: WireContract[],
  skipIncludedAddOns = false,
): WireAddOnContract[] =>
  contracts.filter(
    (contract) =>
      contract.type === "ITEM" &&
      (!skipIncludedAddOns ||
        (contract as WireAddOnContract).meta?.type !== "included"),
  ) as WireAddOnContract[];

/**
 * Quote master: pending update wins over the live `master` when present.
 */
const getQuoteMaster = (
  quote: WireOfferQuote | null | undefined,
): WireOfferQuoteMaster | undefined => {
  if (!quote) return undefined;

  if (quote.pending) {
    return quote.pending.master;
  }

  return quote.master;
};

/**
 * Quote children: pending update children win over live `children`.
 */
const getQuoteChildren = (
  quote: WireOfferQuote | null | undefined,
): WireOfferQuoteChild[] => {
  if (!quote) return [];

  if (quote.pending?.children) {
    return quote.pending.children;
  }

  return quote.children || [];
};

const getQuoteSpaceRentalChild = (
  quote: WireOfferQuote | null | undefined,
): WireOfferQuoteChild | null =>
  getQuoteChildren(quote).find((child) => child.type === "SPACE_RENTAL") ??
  null;

export {
  findAddOnsContracts,
  findMasterContract,
  findSpaceRentalContract,
  getQuoteChildren,
  getQuoteMaster,
  getQuoteSpaceRentalChild,
};
